import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "show", "hide"];

  connect() {
    this.visible = false;
    this.#render();
  }

  toggle() {
    this.visible = !this.visible;
    this.#render();
  }

  #render() {
    this.inputTarget.type = this.visible ? "text" : "password";
    this.showTarget.classList.toggle("hidden", this.visible);
    this.hideTarget.classList.toggle("hidden", !this.visible);

    const button = this.showTarget.closest("button");
    if (button) {
      button.setAttribute("aria-pressed", String(this.visible));
      button.setAttribute("aria-label", this.visible ? "隐藏密码" : "显示密码");
    }
  }
}
